import { useState, useEffect, useMemo } from "react";
import {
  useGetInterventionYieldsByParamQuery,
  useUpdateYieldBatchMutation,
  useUpdateYieldStatusMutation,
} from "../../store/is/yieldapi";
import { fetchEmissionBreakdown } from "../../lib/emissionBreakdown";
import { projectApi } from "../../store/is/projectapi";
import {
  assetApi,
  useAddDocumentToAssetMutation,
} from "../../store/is/assetapi";
import {
  Button,
  Table,
  Modal,
  Spin,
  Card,
  Typography,
  Divider,
  message,
  Popover,
  Dropdown,
  Menu,
  List,
  Tooltip,
  Input,
} from "antd";

import moment from "moment";
import {
  ContactsOutlined,
  DownOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { DisplayUserName } from "../Utils/DisplayUserName";
import { useHistory } from "react-router-dom";
import store from "../../store/store";
import { createEntitlementRecordsUtil } from "./Utils/yieldutils";
import { useTransactionHandlers } from "../../bc-client/useTransactionHandlers";
import {
  createYieldsAction,
  verifyYieldsAction,
  validateYieldsAction,
  createEntitlementRecordsAction,
  createCancelPreCreditsAction,
  acceptCancelOfPreCreditsAction,
} from "../../constants/actionNames";

import { useGetAssignmentByParamQuery } from "../../store/is/assignmentapi";
import AddDocument from "./AddDocument";
import PerformOperationaCheckOnYield from "./Utils/PerformOperationaCheckOnYield";
import HandleYieldButtons from "./HandleYieldButtons";
import {
  useGetPreEntitilementRecordByYieldIdsQuery,
  useLazyGetPreEntitlementRecordByParamQuery,
} from "../../store/is/preentitlementrecordsapi";
import { DisplayOrganization } from "../Utils/DisplayOrganization";
import { generateMessageFromStatus } from "../../bc-client/MessageUtils";

function ViewYields() {
  const [filteredInfo, setFilteredInfo] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowsUpdated, setSelectedRowsUpdated] = useState([]);
  const [openPerformProbaReviewModal, setOpenPerformProbaReviewModal] = useState(false);
  const [confirmLoadingProbaReviewAction, setConfirmLoadingProbaReviewAction] = useState(false);

  const [
    isPerformOperationalCheckOnYield,
    setIsPerformOperationalCheckOnYield,
  ] = useState(false);
  const [openSubmitForOperationalCheckModal, setOpenSubmitForOperationalCheckModal] = useState(false);
  const [openValidatorReviewModal, setOpenValidatorReviewModal] = useState(
    false
  );
  const [openVerifierReviewModal, setOpenVerifierReviewModal] = useState(false);
  const [
    openPerformOperationalCheckModal,
    setOpenPerformOperationalCheckModal,
  ] = useState(false);
  const [
    confirmLoadingSubmitForOperationalCheckModal,
    setConfirmLoadingSubmitForOperationalCheckModal,
  ] = useState(false);
  const [
    confirmLoadingValidatorModal,
    setConfirmLoadingValidatorModal,
  ] = useState(false);
  const [
    confirmLoadingVerifierModal,
    setConfirmLoadingVerifierModal,
  ] = useState(false);
  const [
    confirmLoadingSubmitForVerificationModal,
    setConfirmLoadingSubmitForVerificationModal,
  ] = useState(false);
  const [uplodedDocumentHashes, setUplodedDocumentHashes] = useState([]);

  // Emission breakdown modal state
  const [emissionBreakdownModalOpen, setEmissionBreakdownModalOpen] = useState(false);
  const [emissionBreakdownData, setEmissionBreakdownData] = useState(null);
  const [emissionBreakdownLoading, setEmissionBreakdownLoading] = useState(false);

  let intervention = useSelector((state) => state.is.intervention);
  let asset = useSelector((state) => state.is.asset);

  let userid = useSelector((state) => state.auth.userid);
  const orgId = useSelector((state) => state.auth?.org?._id);

  const [isIntervStsActive, setIntervStsActive] = useState(
    intervention?.status === "Active"
  );
  const [isIntervPreCreditsAvailable, setIntervPreCreditsAvailable] = useState(
    intervention?.pre_credits !== null
  );
  const [isAssetStsActive, setAssetStsActive] = useState(false);

  const [updateYieldBatch] = useUpdateYieldBatchMutation();
  const [updateYieldStatus] = useUpdateYieldStatusMutation();
  const [
    getPreEntitlementRecords,
  ] = useLazyGetPreEntitlementRecordByParamQuery();
  const [projectSponsorOrgId, setProjectSponsorOrgId] = useState();


  const [
    isCreatePreEntitlementRecordsModalVisible,
    setIsCreatePreEntitlementRecordsModalVisible,
  ] = useState(false);

  const [
    isCreateEntitlementRecordsModalVisible,
    setIsCreateEntitlementRecordsModalVisible,
  ] = useState(false);

  const [
    isCancelPreCreditsModalVisible,
    setIsCancelPreCreditsModalVisible,
  ] = useState(false);

  const [
    isAcceptCancelRequestPreCreditsModalVisible,
    setIsAcceptCancelRequestPreCreditsModalVisible,
  ] = useState(false);

  const [openVerificationConfirmationModal, setOpenVerificationConfirmationModal] = useState(false);

  const groups = useSelector((state) => state.auth.groups);
  
  const usergroup = useMemo(() => {
    if (!groups) return [];
    return groups.map((group) => group?.name).filter(Boolean);
  }, [groups]);


  const [addAssetDocument] = useAddDocumentToAssetMutation();

  const {
    data: assignmentData,
    isLoading: isIntervAssignmentDetailsLoading,
  } = useGetAssignmentByParamQuery(
    {
      project_id: intervention?._id,
    },
    { skip: !intervention?._id }
  );

  useEffect(() => {
    if (!isIntervAssignmentDetailsLoading && assignmentData) {
      const matchedRecord = assignmentData.find((record) => {
        return (
          record.asset_id === null &&
          record.yield_id === null &&
          record.assignee_type === "Project Sponsor"
        );
      });
      setProjectSponsorOrgId(matchedRecord?.organization);
    }
  }, [isIntervAssignmentDetailsLoading, assignmentData]);

  const [isSpinning, setSpinning] = useState(false);
  const [isYieldEditing, setIsYieldEditing] = useState(false);
  const [spinningDesc, setSpinningDesc] = useState("Processing...");
  const [isCreateDocument, setIsCreateDocument] = useState(false);
  const [uplodedDocumentList, setUplodedDocumentList] = useState([]);

  const history = useHistory();
  const dispatch = useDispatch();

  const key = "updatable";

  const closeDocumentModal = () => {
    setIsCreateDocument(false);
  };

  const displayDocument = (document) => {
    let uplodedDocumentListToUpdate = [...uplodedDocumentList];
    uplodedDocumentListToUpdate.push({
      docname: document?.docname,
      docdname: document?.document_display_name,
    });
    setUplodedDocumentList(uplodedDocumentListToUpdate);
    updateDocument(document);
  };

  //********bc-client */
  const { onAccept } = useTransactionHandlers({
    actionname: createYieldsAction.name,
  });
  const createYieldsActionInBC = async (payload) => {
    return await onAccept(payload);
  };

  const { onAccept: onAcceptVerifyYields } = useTransactionHandlers({
    actionname: verifyYieldsAction.name,
  });
  const verifyYieldsActionInBC = async (payload) => {
    return await onAcceptVerifyYields(payload);
  };
  const { onAccept: onAcceptvalidateYieldsAction } = useTransactionHandlers({
    actionname: validateYieldsAction.name,
  });
  const validateYieldsActionInBC = async (payload) => {
    return await onAcceptvalidateYieldsAction(payload);
  };

  // Entitlement Records
  const {
    onAccept: onAcceptcreateEntitlementRecordsAction,
  } = useTransactionHandlers({
    actionname: createEntitlementRecordsAction.name,
  });
  const createEntitlementRecordsActionInBC = async (payload) => {
    return await onAcceptcreateEntitlementRecordsAction(payload);
  };

  //********bc-client ends */

  if (!intervention?.name) {
    history.push({
      pathname: `/intervention/list`,
    });
  }

  const viewInterventionRouteChange = () => {
    let path = `/intervention/view`;
    history.push(path);
  };

  const yieldEditModal = () => {
    setIsYieldEditing(true);
  };

  const closeModal = () => {
    setIsYieldEditing(false);
    setSelectedRowKeys([]);
  };

  // Handler for clicking on yield values to show emission breakdown
  const handleYieldValueClick = async (record) => {
    const assetType = record?.asset?.[0]?.type;
    if (assetType === "generic") {
      message.warning("Emission breakdown is not available for generic assets.");
      return;
    }
    if (!intervention?._id || !record?.asset_id || !record?.period) {
      message.warning("Cannot fetch breakdown: missing required data");
      return;
    }
    setEmissionBreakdownLoading(true);
    setEmissionBreakdownModalOpen(true);
    const data = await fetchEmissionBreakdown(
      intervention._id,
      record.asset_id,
      record.period
    );
    setEmissionBreakdownData(data);
    setEmissionBreakdownLoading(false);
  };

  const closeEmissionBreakdownModal = () => {
    setEmissionBreakdownModalOpen(false);
    setEmissionBreakdownData(null);
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  const [searchText, setSearchText] = useState("");

  const handlePeriodSearch = () => {
    setFilteredInfo((prev) => ({
      ...prev,
      period: searchText ? [searchText] : null,
    }));
  };

  const clearPeriodFilter = () => {
    setFilteredInfo((prev) => ({
      ...prev,
      period: null,
    }));
    setSearchText("");
  };

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const formatCreditStatusField = (field) => {
    return field
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const columns = [
    {
      key: "token_id",
      title: "NFRY ID",
      dataIndex: "token_id",
      render: (record) => {
        return <Typography.Text>NFRY-{record}</Typography.Text>;
      },
    },
    {
      key: "external_asset_id",
      title: "External Asset Id",
      dataIndex: "asset",
      render: (asset) => asset?.[0]?.external_asset_id || "",
    },
    {
      key: "period",
      title: "Period",
      dataIndex: "period",
      sorter: (a, b) => (a?.period || "").localeCompare(b?.period || ""),
      filteredValue: filteredInfo?.period || null,
      onFilter: (value, record) =>
        (record?.period || "")
          .toString()
          ?.toLowerCase()
          ?.includes(value?.toLowerCase()),
      filterDropdown: () => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Period"
            value={searchText}
            onChange={(e) => setSearchText(e?.target?.value)}
            onPressEnter={handlePeriodSearch}
            style={{ marginBottom: 8, display: "block" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              type="primary"
              onClick={handlePeriodSearch}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={clearPeriodFilter}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
    },
    {
      key: "storage_duration",
      title: "Storage Duration",
      dataIndex: "storage_duration",
    },
    {
      key: "co2_estimated",
      title: "Estimated tCo2e",
      dataIndex: "co2_estimated",
      render: (value, record) => (
        <Typography.Link onClick={() => handleYieldValueClick(record)}>
          {value ?? "-"}
        </Typography.Link>
      ),
    },
    {
      key: "co2_realized",
      title: "Realized tCo2e",
      dataIndex: "co2_realized",
      render: (value, record) => (
        <Typography.Link onClick={() => handleYieldValueClick(record)}>
          {value ?? "-"}
        </Typography.Link>
      ),
    },
    {
      key: "product_volume",
      title: "Product Volume (Estimated / Realized)",
      dataIndex: "product_volume",
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      filters: [
        {
          text: "New",
          value: "New",
        },
        {
          text: "Eligibility Check",
          value: "Eligibility Check",
        },
        {
          text: "Proba Review",
          value: "Proba Review",
        },
        {
          text: "Revision",
          value: "Revision",
        },
        {
          text: "Pending Realization",
          value: "Pending Realization",
        },
        {
          text: "Validator Review",
          value: "Validator Review",
        },
        {
          text: "Verifier Review",
          value: "Verifier Review",
        },
        {
          text: "Realized",
          value: "Realized",
        },
      ],
      filteredValue: filteredInfo?.status || null,
      onFilter: (value, record) => record?.status?.includes(value),
      sorter: (a, b) => a?.status?.localeCompare(b?.status),
    },
    {
      key: "credit_status",
      title: "Credit Status",
      dataIndex: "credit_status",
      render: (creditStatus) => {
        const trueFields = Object.entries(creditStatus)
          .filter(([key, value]) => value === true)
          .map(([key]) => formatCreditStatusField(key));
        return trueFields.join(", ") || "None";
      },
      filters: [
        { text: "Credits Available", value: "credits_available" },
        { text: "Credits Not Available", value: "credits_not_available" },
        { text: "Pre Credits Available", value: "pre_credits_available" },
        {
          text: "Pre Credits Not Available",
          value: "pre_credits_not_available",
        },
      ],
      filteredValue: filteredInfo?.credit_status || null,
      onFilter: (value, record) => record?.credit_status[value] === true,
    },
    // {
    //   key: "has_entitlement_records",
    //   title: "Pre-Credits Created",
    //   dataIndex: "entitlement_records",
    //   render: (entitlement_records) => {
    //     const hasEntitlementRecords = entitlement_records.length > 0;
    //     return (
    //       <Popover
    //         content={
    //           hasEntitlementRecords ? (
    //             <>
    //               {entitlement_records.map((record, index) => (
    //                 <div key={index} style={{ display: "flex", alignItems: "center" }}>
    //                   <DisplayUserName userid={record.owner_of_entitlement_records} place="table" /> : {record.no_of_entitlement_record}
    //                 </div>
    //               ))}
    //             </>
    //           ) : (
    //             "No entitlement records found"
    //           )
    //         }
    //       >
    //         <span style={{ cursor: hasEntitlementRecords ? "pointer" : "default" }}>
    //           {hasEntitlementRecords ? "Yes" : "No"}
    //           {hasEntitlementRecords && <InfoCircleOutlined style={{ marginLeft: 4 }} />}
    //         </span>
    //       </Popover>
    //     );
    //   }
    // },
    {
      key: "creator",
      title: "Creator",
      dataIndex: "creator",
      render: (record) => {
        return <DisplayUserName userid={record} place="table" />;
      },
    },
    {
      key: "updator",
      title: "Updator",
      dataIndex: "updator",
      render: (record) => {
        return <DisplayUserName userid={record} place="table" />;
      },
    },
    {
      key: "created",
      title: "Created",
      dataIndex: "created",
      render: (record) => {
        return (
          <span>
            {record
              ? moment
                  .utc(record)
                  .local()
                  .format("DD MMM, YYYY @ hh:mm:ss")
              : undefined}
          </span>
        );
      },
    },
    {
      key: "updated",
      title: "Updated",
      dataIndex: "updated",
      render: (record) => {
        return (
          <span>
            {record
              ? moment
                  .utc(record)
                  .local()
                  .format("DD MMM, YYYY @ hh:mm:ss")
              : undefined}
          </span>
        );
      },
    },
    {
      key: "user_id",
      title: "Assignees",
      dataIndex: "user_id",
      visible: usergroup.includes("Project Developer"),
      render: (text, record) => {
        let verifier_org_id, validator_org_id, project_sponsor_org_id;
        if (Array.isArray(record?.assignment)) {
          record?.assignment?.map((assignment) => {
            if (assignment.assignee_type === "Verifier") {
              verifier_org_id = assignment?.organization;
            }
            if (assignment.assignee_type === "Validator") {
              validator_org_id = assignment?.organization;
            }
            if (assignment.assignee_type === "Project Sponsor") {
              project_sponsor_org_id = assignment?.organization;
            }
          });
          return (
            <Popover
              content={
                <>
                  <Typography.Text strong>Verifier:</Typography.Text>
                  <DisplayOrganization orgid={verifier_org_id} place="table" />
                  <Typography.Text strong>Validator:</Typography.Text>
                  <DisplayOrganization orgid={validator_org_id} place="table" />
                  <Typography.Text strong>Project Sponsor:</Typography.Text>
                  <DisplayOrganization
                    orgid={project_sponsor_org_id}
                    place="table"
                  />
                </>
              }
            >
              <ContactsOutlined />
            </Popover>
          );
        } else {
          return (
            <Popover content={<></>}>
              <ContactsOutlined />
            </Popover>
          );
        }
      },
    },
  ].filter(Boolean); //remove null columns

  if (usergroup.includes("Project Developer")) {
    columns.push({
      key: "6",
      title: "Actions",
      render: (record) => {
        const isEditableStatus = [
          "New",
          "Revision",
          "Pending Realization",
        ].includes(record?.status);
        const tooltipTitle = "Cannot edit";

        if (isEditableStatus) {
          return (
            <>
              <EditOutlined
                onClick={() => {
                  setSelectedRowsUpdated([record]);
                  yieldEditModal();
                }}
                style={{ marginRight: 10 }}
              />
              <Divider type="vertical" />
            </>
          );
        } else {
          return (
            <>
              <Tooltip title={tooltipTitle}>
                <EditOutlined style={{ marginRight: 10, opacity: 0.5 }} />
              </Tooltip>
              <Divider type="vertical" />
            </>
          );
        }
      },
    });
  }
  const {
    data: interventionYieldData,
    refetch: refetchYields,
  } = useGetInterventionYieldsByParamQuery(
    {
      project_id: intervention?._id,
    },
    { skip: !intervention?._id }
  );


  const {
    data: pre_entitlement_data,
    isLoading: isPreEntitlementDataLoading,
    refetch: refetch_pre_entitlement_data,
  } = useGetPreEntitilementRecordByYieldIdsQuery(
    {
      project_id: intervention?._id,
    },
    { skip: !intervention?._id }
  );


  const hasPreEntitlementRecords = (record) => {
    const matchingData = pre_entitlement_data?.data?.filter(
      (item) => item.yield_id === record._id
    );
    return matchingData.length > 0;
  };

  const resetButtonStates = () => {
    setSelectedRowKeys([]);
  };

  const handleMakeAvailable = (selectedRows) => {
    setSelectedRowsUpdated(selectedRows);
  };

  const getAssetsByIds = async (assetids) => {
    var assetIdsString = assetids.join(",");
    const { data: assetDetails, isLoading } = await store.dispatch(
      assetApi.endpoints.getAssetsByIds.initiate({ assetids: assetIdsString })
    );
    if (!isLoading) {
      return assetDetails ? assetDetails?.data : null;
    }
  };

  const handleSelectedRows = async (selectedRows) => {
    const assetIdsList = [
      ...new Set(selectedRows?.map((row) => row?.asset_id)),
    ];

    const assetsDetails = await getAssetsByIds(assetIdsList);
    const assetsStatuses = [
      ...new Set(assetsDetails?.map((row) => row.status)),
    ];

    const allAssetsActive =
      assetsStatuses?.length > 0 &&
      assetsStatuses?.every((status) => status === "Active");
    setAssetStsActive(allAssetsActive);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: async (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      handleMakeAvailable(selectedRows);

      const userRoles = [
        "Project Developer",
        "Proba Operator",
        "Validator",
        "Verifier",
      ];
      const userHasRole = (roles) =>
        roles.some((role) => usergroup.includes(role));

      // Define role-based validation conditions
      const roleValidations = {
        "Project Developer": {
          validStatuses: ["New", "Revision", "Pending Realization", "Realized"],
          warningMessage:
            'Please select yields with the same status of "New" or "Revision" or "Pending Realization" or "Realized" for actions.',
        },
        "Proba Operator": {
          validStatuses: ["Eligibility Check", "Proba Review"],
          warningMessage:
            'Please select yields with the same status of "Eligibility Check" or "Proba Review" for actions.',
        },
        Validator: {
          validStatuses: ["Validator Review"],
          warningMessage:
            'Please select yields with the same status of "Validator Review" for actions.',
        },
        Verifier: {
          validStatuses: ["Verifier Review"],
          warningMessage:
            'Please select yields with the same status of "Verifier Review" for actions.',
        },
      };

      // Collect all valid statuses for the user's roles
      let combinedValidStatuses = [];
      let combinedWarningMessages = [];

      for (const role of userRoles) {
        if (userHasRole([role])) {
          combinedValidStatuses = combinedValidStatuses.concat(
            roleValidations[role].validStatuses
          );
          combinedWarningMessages.push(roleValidations[role].warningMessage);
        }
      }

      if (selectedRowKeys.length === 0) {
        message.destroy();
        return;
      }

      const selectedStatuses = new Set(selectedRows.map((row) => row.status));
      const isValidSelection =
        selectedStatuses.size === 1 &&
        combinedValidStatuses.includes(selectedRows[0].status);

      if (!isValidSelection) {
        message.warning(
          `Please select yields with the same status of ${combinedValidStatuses.join(
            ", "
          )} for actions.`
        );
        return;
      }

      // Perform additional checks for roles that have them
      for (const role of userRoles) {
        if (userHasRole([role]) && roleValidations[role].additionalCheck) {
          await roleValidations[role].additionalCheck();
        }
      }

      message.destroy();

      handleSelectedRows(selectedRows);
    },
  };

  const updateDocument = (document) => {
    handleAddInterventionDocument(document);
  };

  const handleAddInterventionDocument = async (record) => {
    try {
      //get unique list of assets from yields
      const uniqueAsset = {};
      const uniqueAssetsList = selectedRowsUpdated.filter((yieldRecord) => {
        if (!uniqueAsset[yieldRecord?.asset_id]) {
          uniqueAsset[yieldRecord?.asset_id] = true;
          return true;
        }
        return false;
      });

      for (let i = 0; i < uniqueAssetsList.length; i++) {
        const body = {
          assetid: uniqueAssetsList[i]?.asset_id,
          requestbody: {
            document_id: record?.document_id,
            asset_id: uniqueAssetsList[i]?.asset_id,
          },
        };
        await addAssetDocument(body)
          .unwrap()
          .then((res) => {})
          .catch((err) => {
            console.error("Error creating entitlement records:", err);
          });
      }
    } catch {}
  };

  const postUpdateCreateEntitilementRecords = (yieldstatusupdate) => {
  };

  const handleDispatchSubmitForOperationalCheck = (yieldUpdateResponse) => {
    refetchYields();
    setSelectedRowKeys([]);
  };

  const handleDispatchPerformOperationalCheck = (yieldUpdateResponse) => {
    refetchYields();
    setSelectedRowKeys([]);
    setIsPerformOperationalCheckOnYield(false);
  };

  const handleYieldEditRecord = async (record) => {
    try {
      const payload = {
        body: record,
      };
    
      const res = await updateYieldStatus(payload)
        .unwrap()
        .then((res) => {
          message.success({
            content: "Yield updated successfully!",
            key,
            duration: 2,
          });
          refetchYields();
          setSelectedRowKeys([]);
          return res;
        })
        .catch((err) => {
          console.error("Failed to update yield:", err);
          message.error({
            content: "Failed to update yield: " + Object.values(err["data"])[0],
            key,
            duration: 6,
          });
        });
      return res;
    } catch {}
  };

  const closeSubmitForOperationalCheck = () => {
    setOpenSubmitForOperationalCheckModal(false);
  };

  const closePerformOperationalCheck = () => {
    setOpenPerformOperationalCheckModal(false);
    setIsPerformOperationalCheckOnYield(false);
  };

  const handleSubmitForOperationalCheck = () => {
    setOpenSubmitForOperationalCheckModal(true);
  };

  const handlePerfomOperationalCheck = () => {
    setOpenPerformOperationalCheckModal(true);
    setIsPerformOperationalCheckOnYield(true);
  };

  const closeValidatorReview = () => {
    setOpenValidatorReviewModal(false);
  };

  const handleValidatorReview = () => {
    setOpenValidatorReviewModal(true);
  };

  const closeVerifierReview = () => {
    setOpenVerifierReviewModal(false);
  };

  const handleVerifierReview = () => {
    setOpenVerifierReviewModal(true);
  };

  const totalPreCredits = intervention?.pre_credits || 0;
  const sponsorPreCreditsAvailability =
    intervention?.sponsor_pre_credits_flag || false;

  const handleOkOfSubmitForOperationalCheckModal = async () => {
    try {
      setSpinning(true);
      let yieldStatusUpdate = {};

      if (!usergroup.includes("Project Developer")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
        return;
      }
      let yiedlsDataListBlockchain = [];
      let yieldsList = [];
      for (let i = 0; i < selectedRowsUpdated?.length; i++) {
        yieldStatusUpdate = { ...selectedRowsUpdated[i] };
        if (yieldStatusUpdate?.status === "New") {
          yieldStatusUpdate["status"] = "Eligibility Check";
          yiedlsDataListBlockchain.push(yieldStatusUpdate);
        } else {
          yieldStatusUpdate["status"] = "Eligibility Check";
          yieldsList.push(yieldStatusUpdate);
        }
      }
      if (yiedlsDataListBlockchain?.length > 0) {
        const payload = {
          yields: yiedlsDataListBlockchain,
          projectId: intervention?._id
        };

        const resultYields = await createYieldsActionInBC(payload);
        if (!resultYields) {
          return;
        }
      }
      if (yieldsList.length > 0) {
        await updateYieldBatch(yieldsList);
        generateMessageFromStatus({
          status: "success",
          message:
            "Yield successfully submitted to the blockchain for processing",
        });
      }
    } catch (error) {
      console.error(
        "Error updating yield or calling blockchain function:",
        error
      );
    } finally {
      setConfirmLoadingSubmitForOperationalCheckModal(false);
      setOpenSubmitForOperationalCheckModal(false);
      setSpinning(false);
      setSelectedRowKeys([]);
    }
  };

  const handleMarkAsRealized = async () => {
    try {
      setSpinning(true);
      setConfirmLoadingProbaReviewAction(true);
      const yieldStatusUpdate = {};
      yieldStatusUpdate["_ids"] = selectedRowKeys;
      yieldStatusUpdate["status"] = "Realized";

      if (!usergroup.includes("Proba Operator")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
        return;
      }
      await handleYieldEditRecord(yieldStatusUpdate);
    } catch (error) {
      console.error("Error updating yield:", error);
    } finally {
      setConfirmLoadingProbaReviewAction(false);
      setOpenPerformProbaReviewModal(false);
      setSpinning(false);
      setSelectedRowKeys([]);
    }
  };

  const handleProbaReviewRevision = async () => {
    try {
      setSpinning(true);
      setConfirmLoadingProbaReviewAction(true);
      const yieldStatusUpdate = {};
      yieldStatusUpdate["_ids"] = selectedRowKeys;
      yieldStatusUpdate["status"] = "Revision";

      if (!usergroup.includes("Proba Operator")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
        return;
      }
      await handleYieldEditRecord(yieldStatusUpdate);
    } catch (error) {
      console.error("Error updating yield:", error);
    } finally {
      setConfirmLoadingProbaReviewAction(false);
      setOpenPerformProbaReviewModal(false);
      setSpinning(false);
      setSelectedRowKeys([]);
    }
  };

  const handleOkOfValidatorModal = async () => {
    try {
      setConfirmLoadingValidatorModal(true);
      setSpinning(true);
      const yieldStatusUpdate = {};
      yieldStatusUpdate["_ids"] = selectedRowKeys;
      yieldStatusUpdate["status"] = "Pending Realization";

      if (!usergroup.includes("Validator")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        const result = await validateYieldsActionInBC({
          yields: selectedRowsUpdated,
          dochashes: uplodedDocumentHashes,
          projectId: intervention?._id
        });
        if (!result) {
          return;
        }
        await handleYieldEditRecord(yieldStatusUpdate);
      }
    } catch (error) {
      console.error("Error updating yield:", error);
    } finally {
      setConfirmLoadingValidatorModal(false);
      setOpenValidatorReviewModal(false);
      setSpinning(false);
      setSelectedRowKeys([]);
    }
  };

  const handleMakeYieldRevision = async () => {
    try {
      const yieldStatusUpdate = {};
      yieldStatusUpdate["_ids"] = selectedRowKeys;
      yieldStatusUpdate["status"] = "Revision";
      setConfirmLoadingValidatorModal(true);
      if (
        !usergroup.some((role) =>
          ["Verifier", "Validator", "Project Developer", "Proba Operator"].includes(role)
        )
      ) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        await handleYieldEditRecord(yieldStatusUpdate);
      }
    } catch (error) {
      console.error("Error updating yield:", error);
    } finally {
      setConfirmLoadingVerifierModal(false);
      setConfirmLoadingValidatorModal(false);
      setOpenValidatorReviewModal(false);
      setOpenVerifierReviewModal(false);
      setSelectedRowKeys([]);
    }
  };

  const handleOkOfVerifierModal = async () => {
    try {
      setSpinning(true);
      setConfirmLoadingVerifierModal(true);
      const yieldStatusUpdate = {};
      yieldStatusUpdate["_ids"] = selectedRowKeys;
      yieldStatusUpdate["status"] = "Proba Review";

      if (!usergroup.includes("Verifier")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        const result = await verifyYieldsActionInBC({
          yields: selectedRowsUpdated,
          dochashes: uplodedDocumentHashes,
          projectId: intervention?._id
        });
        if (!result) {
          return;
        }
        await handleYieldEditRecord(yieldStatusUpdate);
      }
    } catch (error) {
      console.error("Error updating yield:", error);
    } finally {
      setConfirmLoadingVerifierModal(false);
      setOpenVerifierReviewModal(false);
      setSpinning(false);
      setSelectedRowKeys([]);
    }
  };

  const  handleSubmittingYieldForVerification =async ()=>{
    try {
      setSpinning(true);
      if (!usergroup.some((group) => group === "Project Developer")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        const yieldStatusUpdate = {};
        yieldStatusUpdate["_ids"] = selectedRowKeys;
        yieldStatusUpdate["status"] = "Verifier Review";
        await handleYieldEditRecord(yieldStatusUpdate);
      }
    } catch (error) {
      console.error("Error updating asset:", error);
    } finally {
      setOpenVerificationConfirmationModal(false);
      setSpinning(false);
      setSelectedRowKeys([]);
    }
  }

  const handleOkOfPreEntitlementsRecordModal = async (flag) => {
    setConfirmLoadingVerifierModal(true);
    try {
      if (!usergroup.includes("Project Developer")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        const inputYields = selectedRowsUpdated;
        const entitlementRecordDetails = [];
        inputYields.forEach((yieldData) => {
          const matchedPreEntitlement = pre_entitlement_data?.data?.filter(
            (preEntitlement) => preEntitlement?.yield_id === yieldData?._id
          );
          if (matchedPreEntitlement?.length > 0) {
            entitlementRecordDetails.push(...matchedPreEntitlement);
          }
        });
        await createEntitlementRecordsUtil(
          inputYields,
          entitlementRecordDetails,
          projectSponsorOrgId,
          flag,
          totalPreCredits,
          sponsorPreCreditsAvailability,
          setSpinning,
          createEntitlementRecordsActionInBC,
          getPreEntitlementRecords,
          postUpdateCreateEntitilementRecords,
          userid,
          refetchYields
        );
      }
    } catch (error) {
      console.error("Error updating pre credits records:", error);
    } finally {
      setIsCreatePreEntitlementRecordsModalVisible(false);
      setIsCreateEntitlementRecordsModalVisible(false);
      setSelectedRowKeys([]);
      refetch_pre_entitlement_data();
      setConfirmLoadingVerifierModal(false);
    }
  };

  // BC-client  cancel pre credits
  const {
    onAccept: onAcceptcreateCancelPreCreditsAction,
  } = useTransactionHandlers({
    actionname: createCancelPreCreditsAction.name,
  });
  const createCancelPreCreditsActionnInBC = async (payload) => {
    return await onAcceptcreateCancelPreCreditsAction(payload);
  };

  // BC-client  Accept cancel pre credits

  const {
    onAccept: onAcceptacceptCancelOfPreCreditsAction,
  } = useTransactionHandlers({
    actionname: acceptCancelOfPreCreditsAction.name,
  });
  const acceptCancelOfPreCreditsActionnInBC = async (payload) => {
    return await onAcceptacceptCancelOfPreCreditsAction(payload);
  };

  //cancel pre-credits

  const handleOkOfCancelPreCreditsModal = async () => {
    try {
      if (!usergroup.includes("Project Developer")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      }
      setSpinning(true);
      const entitlementRecordDetails = [];
      selectedRowsUpdated.forEach((yieldData) => {
        const matchedPreEntitlement = pre_entitlement_data?.data?.filter(
          (preEntitlement) => preEntitlement?.yield_id === yieldData?._id
        );
        if (matchedPreEntitlement?.length > 0) {
          matchedPreEntitlement?.forEach((preEntitlement) => {
            if (preEntitlement?.owner_of_entitlement_records !== userid) {
              const updatedPreEntitlement = {
                ...preEntitlement,
                status: "pendingapproval",
              };
              const combinedData = {
                ...updatedPreEntitlement,
                yield_details: yieldData,
              };
              entitlementRecordDetails.push(combinedData);
            }
          });
        }
      });

      const result = await createCancelPreCreditsActionnInBC(
        entitlementRecordDetails
      );
      if (!result) {
        return;
      }
    } catch (error) {
      console.error("Error updating intervention:", error);
    } finally {
      setSpinning(false);
      setIsCancelPreCreditsModalVisible(false);
    }
  };

  const handleOkOfAcceptPreCreditsCancelModal = async () => {
    try {
      if (!usergroup.includes("Project Sponsor")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      }

      setSpinning(true);
      const entitlementRecordDetails = [];
      selectedRowsUpdated.forEach((yieldData) => {
        const matchedPreEntitlement = pre_entitlement_data?.data?.filter(
          (preEntitlement) => preEntitlement?.yield_id === yieldData?._id
        );
        if (matchedPreEntitlement?.length > 0) {
          matchedPreEntitlement.forEach((preEntitlement) => {
            if (preEntitlement?.owner_of_entitlement_records == userid) {
              const updatedPreEntitlement = {
                ...preEntitlement,
                status: "realized",
              };
              const combinedData = {
                ...updatedPreEntitlement,
                yield_details: yieldData,
              };
              entitlementRecordDetails.push(combinedData);
            }
          });
        }
      });

      const result = await acceptCancelOfPreCreditsActionnInBC(
        entitlementRecordDetails
      );
      if (!result) {
        message.error({
          content: "Bc action failed",
          key,
          duration: 4,
        });
        return;
      }
    } catch (error) {
      console.error("Error updating intervention:", error);
    } finally {
      setSpinning(false);
      setIsAcceptCancelRequestPreCreditsModalVisible(false);
    }
  };

  const menu = (
    <Menu>
      {usergroup.includes("Project Developer") &&
        intervention?.organization === orgId && (
          <>
            <Menu.Item key="submitForOperationalCheck">
              <Button
                type="link"
                onClick={handleSubmitForOperationalCheck}
                disabled={
                  !isAssetStsActive ||
                  !isIntervStsActive ||
                  selectedRowKeys?.length === 0 ||
                  !selectedRowsUpdated?.every((row) =>
                    ["New", "Revision"].includes(
                      row?.status
                    )
                  ) 
                }
              >
                Submit for Eligibility Check
              </Button>
            </Menu.Item>
          </>
        )}

      {usergroup.includes("Proba Operator") && (
        <>
          <Menu.Item key="PerformOperationalCheck">
            <Button
              type="link"
              onClick={handlePerfomOperationalCheck}
              disabled={
                !isAssetStsActive ||
                !isIntervStsActive ||
                selectedRowKeys?.length === 0 ||
                !selectedRowsUpdated?.every(
                  (row) => row.status === "Eligibility Check"
                )
              }
            >
              Perform Eligibility Check
            </Button>
          </Menu.Item>
          <Menu.Item key="PerformProbaReview">
            <Button
              type="link"
              onClick={() => setOpenPerformProbaReviewModal(true)}
              disabled={
                !isAssetStsActive ||
                !isIntervStsActive ||
                selectedRowKeys?.length === 0 ||
                !selectedRowsUpdated?.every(
                  (row) => row.status === "Proba Review"
                )
              }
            >
              Perform Proba Review
            </Button>
          </Menu.Item>
        </>
      )}

      {usergroup.includes("Project Developer") && (
        <>
          <Menu.Item key="PerformOperationalCheck">
            <Button
              type="link"
              onClick={() => setOpenVerificationConfirmationModal(true)}
              disabled={
                !selectedRowsUpdated?.every((row) =>
                    [ "Pending Realization"].includes(
                      row?.status
                    )
                  ) || (selectedRowsUpdated?.some(
                  (row) => row?.status === "Pending Realization"
                ) &&
                  !selectedRowsUpdated?.every(
                    (row) => row?.co2_realized && row?.co2_realized !== null
                  ))
              }
            >
              Submit for Verification
            </Button>
          </Menu.Item>
        </>
      )}

      {usergroup.includes("Validator") && (
        <Menu.Item key="YieldPerformValidation">
          <>
            <Button
              type="link"
              // TODO disabled={!isYieldPerformValidationButton}
              disabled={
                !isAssetStsActive ||
                !isIntervStsActive ||
                !selectedRowsUpdated?.every(
                  (row) => row?.status === "Validator Review"
                ) ||
                selectedRowKeys?.length === 0 ||
                !selectedRowsUpdated?.every((row) =>
                  row?.assignment?.some(
                    (assignee) =>
                      assignee?.assignee_type === "Validator" &&
                      assignee?.organization === orgId
                  )
                )
              }
              onClick={handleValidatorReview}
            >
              Perform Validation
            </Button>
          </>
        </Menu.Item>
      )}
      {usergroup.includes("Verifier") && (
        <Menu.Item key="YieldPerformVerification">
          <>
            <Button
              type="link"
              // TODO disabled={!isYieldPerformVerificationButton}
              disabled={
                !isAssetStsActive ||
                !isIntervStsActive ||
                !selectedRowsUpdated?.every(
                  (row) => row?.status === "Verifier Review"
                ) ||
                selectedRowKeys?.length === 0 ||
                !selectedRowsUpdated?.every((row) =>
                  row?.assignment?.some(
                    (assignee) =>
                      assignee?.assignee_type === "Verifier" &&
                      assignee?.organization === orgId
                  )
                )
              }
              onClick={handleVerifierReview}
            >
              Perform Verification
            </Button>
          </>
        </Menu.Item>
      )}
      {!usergroup.includes("Verifier") &&
        !usergroup.includes("Validator") &&
        usergroup.includes("Project Developer") &&
        intervention?.organization === orgId && (
          <Menu.Item key=" CreatePreEntitlementRecords">
            <>
              <Button
                type="link"
                disabled={
                  !isAssetStsActive ||
                  !isIntervStsActive ||
                  !isIntervPreCreditsAvailable ||
                  selectedRowKeys?.length === 0 ||
                  (intervention?.sponsor_pre_credits_flag &&
                    !intervention?.assignment?.some(
                      (assignee) =>
                        assignee?.assignee_type === "Project Sponsor"
                    )) ||
                  !selectedRowsUpdated?.every(
                    (row) => row?.status === "Pending Realization"
                  ) ||
                  selectedRowKeys?.some((rowKey) => {
                    const record = interventionYieldData?.data.find(
                      (item) => item?._id === rowKey
                    );
                    return record && hasPreEntitlementRecords(record);
                  }) ||
                  (selectedRowKeys?.length > 0 &&
                    !selectedRowKeys?.some((rowKey) => {
                      const record = interventionYieldData?.data?.find(
                        (item) => item?._id === rowKey
                      );
                      return record && !hasPreEntitlementRecords(record);
                    })) ||
                  selectedRowKeys.some((rowKey) => {
                    const record = interventionYieldData?.data.find(
                      (item) => item._id === rowKey
                    );
                    return (
                      record &&
                      record.co2_realized != null &&
                      record.co2_realized > 0
                    );
                  })
                }
                onClick={async () => {
                  setIsCreatePreEntitlementRecordsModalVisible(true);
                  resetButtonStates(); // Reset button states
                }}
              >
                Create Pre-Credits
              </Button>
            </>
          </Menu.Item>
        )}
      {!usergroup.includes("Verifier") &&
        !usergroup.includes("Validator") &&
        usergroup.includes("Project Developer") &&
        intervention?.organization === orgId && (
          <Menu.Item key="CancelPrecredits">
            <>
              <Button
                type="link"
                disabled={
                  selectedRowKeys.length === 0 ||
                  !intervention?.sponsor_pre_credits_flag ||
                  !selectedRowsUpdated.every(
                    (row) => row?.status === "Realized"
                  ) ||
                  !selectedRowsUpdated.every((row) => {
                    const preCreditsPercentage =
                      row?.co2_estimated * (intervention?.pre_credits / 100);
                    return row?.co2_realized < preCreditsPercentage;
                  })
                }
                onClick={async () => {
                  setIsCancelPreCreditsModalVisible(true);
                  resetButtonStates();
                }}
              >
                Cancel Pre-credits
              </Button>
            </>
          </Menu.Item>
        )}

      {!usergroup.includes("Verifier") &&
        !usergroup.includes("Validator") &&
        usergroup.includes("Project Sponsor") && (
          <Menu.Item key=" acceptcancelrequest">
            <>
              <Button
                type="link"
                disabled={
                  selectedRowKeys?.length === 0 ||
                  !intervention?.sponsor_pre_credits_flag ||
                  !selectedRowsUpdated?.every(
                    (row) => row?.status === "Realized"
                  ) ||
                  selectedRowKeys?.some((rowKey) => {
                    const matchingData = pre_entitlement_data?.data?.filter(
                      (item) => item?.yield_id === rowKey
                    );
                    return (
                      matchingData &&
                      !matchingData?.some(
                        (item) => item?.status === "pendingapproval"
                      )
                    );
                  })
                }
                onClick={async () => {
                  setIsAcceptCancelRequestPreCreditsModalVisible(true);
                  resetButtonStates(); // Reset button states
                }}
              >
                Accept cancel request
              </Button>
            </>
          </Menu.Item>
        )}

      {!usergroup.includes("Verifier") &&
        !usergroup.includes("Validator") &&
        (usergroup.includes("Project Developer") ||
          usergroup.includes("Project Sponsor")) &&
        intervention?.organization === orgId && (
          <Menu.Item key=" CreateEntitlementRecords">
            <>
              <Button
                type="link"
                disabled={
                  !isAssetStsActive ||
                  !isIntervStsActive ||
                  !selectedRowsUpdated?.every(
                    (row) => row?.status === "Realized"
                  ) ||
                  selectedRowKeys?.length === 0 ||
                  selectedRowsUpdated?.some((row) => {
                    const matchingData = pre_entitlement_data?.data?.filter(
                      (item) => item?.yield_id === row._id
                    );
                    if (matchingData?.length === 0) {
                      return false;
                    } else {
                      return matchingData?.some(
                        (item) =>
                          item?.organization_id === orgId &&
                          (item?.status === "realized" ||
                            item?.status === "inactive")
                      );
                    }
                  })
                }
                onClick={async () => {
                  setIsCreateEntitlementRecordsModalVisible(true);
                  resetButtonStates(); // Reset button states
                }}
              >
                Create Entitlement Records
              </Button>
            </>
          </Menu.Item>
        )}
    </Menu>
  );

  return (
    <Spin tip={spinningDesc} spinning={isSpinning} size="large">
      {!isIntervAssignmentDetailsLoading && (
        <div style={{ height: "80vh" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography.Title level={4}>Yield Details</Typography.Title>
            <div>
              {
                <>
                  <Divider type="vertical"></Divider>
                  <Dropdown overlay={menu} trigger={["hover"]}>
                    <Button type="primary">
                      Actions <DownOutlined />
                    </Button>
                  </Dropdown>
                </>
              }
              <Divider type="vertical"></Divider>
              <Button
                type="primary"
                onClick={() => {
                  viewInterventionRouteChange();
                  //refetch the table
                  dispatch(projectApi.util.resetApiState());
                }}
              >
                Back
              </Button>
            </div>
          </div>
          <Card className="shadow-card" style={{ borderRadius: 8 }}>
            <Table
              size="small"
              columns={columns}
              dataSource={interventionYieldData?.data}
              rowKey={(record) => record?._id}
              rowSelection={rowSelection}
              onChange={handleChange}
              pagination={{
                pageSizeOptions: ["10", "50", "100"],
                showSizeChanger: true,
              }}
            ></Table>
          </Card>
        </div>
      )}

      <PerformOperationaCheckOnYield
        yieldData={selectedRowsUpdated}
        yieldIds={selectedRowKeys}
        assetDetails={asset}
        usergroup={usergroup}
        isCreate={isPerformOperationalCheckOnYield}
        closeModal={closePerformOperationalCheck}
        handleDispatchPerformOperationalCheck={
          handleDispatchPerformOperationalCheck
        }
      />

      <Modal
        title="Confirmation"
        visible={isCreatePreEntitlementRecordsModalVisible}
        onCancel={() => setIsCreatePreEntitlementRecordsModalVisible(false)}
        onOk={() => handleOkOfPreEntitlementsRecordModal("preentitlement")}
        confirmLoading={confirmLoadingVerifierModal}
      >
        <p>Are you sure you want to create Pre-Credits ?</p>
      </Modal>

      <Modal
        title="Submit for Verification"
        open={openVerificationConfirmationModal}
        onOk={handleSubmittingYieldForVerification}
        okText="Submit for Verification"
        confirmLoading={confirmLoadingSubmitForVerificationModal}
        onCancel={() => setOpenVerificationConfirmationModal(false)}
      >
        <p>Are you sure you want to submit selected yields for Verification?</p>
      </Modal>

      <Modal
        title="Confirmation"
        visible={isCreateEntitlementRecordsModalVisible}
        onCancel={() => setIsCreateEntitlementRecordsModalVisible(false)}
        onOk={() => handleOkOfPreEntitlementsRecordModal("entitlement")}
        confirmLoading={confirmLoadingVerifierModal}
      >
        <p>Are you sure you want to create Entitlement Records ?</p>
      </Modal>

      <Modal
        title="Confirmation"
        visible={isCancelPreCreditsModalVisible}
        onCancel={() => setIsCancelPreCreditsModalVisible(false)}
        onOk={() => handleOkOfCancelPreCreditsModal()}
      >
        <p>Are you sure you want to cancel Pre-Credits ?</p>
      </Modal>

      <Modal
        title="Confirmation"
        visible={isAcceptCancelRequestPreCreditsModalVisible}
        onCancel={() => setIsAcceptCancelRequestPreCreditsModalVisible(false)}
        onOk={() => handleOkOfAcceptPreCreditsCancelModal()}
      >
        <p>Are you sure you want to accept the cancel Pre-Credits request ?</p>
      </Modal>

      <Modal
        title="Submit for Eligibility Check"
        open={openSubmitForOperationalCheckModal}
        onOk={handleOkOfSubmitForOperationalCheckModal}
        okText="Submit for Eligibility Check"
        confirmLoading={confirmLoadingSubmitForOperationalCheckModal || isSpinning}
        onCancel={() => {
          if (!(confirmLoadingSubmitForOperationalCheckModal || isSpinning))
            closeSubmitForOperationalCheck();
        }}
      >
        <p>Are you sure you want to submit selected yields for Eligibility Check?</p>
      </Modal>

      <Modal
        title="Perform Proba Review"
        open={openPerformProbaReviewModal}
        confirmLoading={confirmLoadingProbaReviewAction || isSpinning}
        onCancel={() => {
          if (!(confirmLoadingProbaReviewAction || isSpinning))
            setOpenPerformProbaReviewModal(false);
        }}
        footer={[
          <Button
            key="revision"
            onClick={handleProbaReviewRevision}
            style={{ color: "red" }}
            loading={confirmLoadingProbaReviewAction}
          >
            Revision
          </Button>,
          <Button
            key="realized"
            type="primary"
            onClick={handleMarkAsRealized}
            loading={confirmLoadingProbaReviewAction}
          >
            Mark as Realized
          </Button>,
        ]}
      >
        <p>Upload the Proba Review Document</p>
        <Button
          type="primary"
          onClick={() => {
            setIsCreateDocument(true);
          }}
        >
          Upload Documents
        </Button>
        <br />
        {uplodedDocumentList?.length > 0 && (
          <List
            dataSource={uplodedDocumentList}
            renderItem={(item) => (
              <List.Item>
                <Typography.Text>{item?.docname}</Typography.Text>
                <Typography.Text>{item?.docdname}</Typography.Text>
              </List.Item>
            )}
          />
        )}
        <br />
        <p>Please select an action for the selected yields:</p>
        <ul>
          <li><strong>Mark as Realized</strong> - Finalize the yield and mark it as realized</li>
          <li><strong>Revision</strong> - Send the yield back for revision</li>
        </ul>
      </Modal>

      <Modal
        title="Submit for Pending Realization"
        open={openValidatorReviewModal}
        okText="Submit for Pending Realization"
        confirmLoading={confirmLoadingValidatorModal}
        onCancel={closeValidatorReview}
        footer={[
          <Button onClick={handleMakeYieldRevision} style={{ color: "red" }}>
            Revise
          </Button>,
          <Button
            type="primary"
            onClick={handleOkOfValidatorModal}
            loading={confirmLoadingValidatorModal}
          >
            Submit for Pending Realization
          </Button>,
        ]}
      >
        <p>Upload the Validation Document</p>
        <Button
          type="primary"
          onClick={() => {
            setIsCreateDocument(true);
          }}
        >
          Upload Documents
        </Button>
        <br />
        {uplodedDocumentList?.length > 0 && (
          <List
            dataSource={uplodedDocumentList}
            renderItem={(item) => (
              <List.Item>
                <Typography.Text>{item.docname}</Typography.Text>
                <Typography.Text>{item.docdname}</Typography.Text>
              </List.Item>
            )}
          />
        )}
        <br />
        <p>
          Are you sure you want to submit selected yields for pending
          realization?
        </p>
      </Modal>

      <Modal
        title="Complete the Verification"
        open={openVerifierReviewModal}
        okText="Complete the Verification"
        confirmLoading={confirmLoadingVerifierModal}
        onCancel={closeVerifierReview}
        footer={[
          <Button onClick={handleMakeYieldRevision} style={{ color: "red" }}>
            Revise
          </Button>,
          <Button
            type="primary"
            onClick={handleOkOfVerifierModal}
            loading={confirmLoadingVerifierModal}
          >
            Complete the Verification
          </Button>,
        ]}
      >
        <p>Upload the Verification Document</p>
        <Button
          type="primary"
          onClick={() => {
            setIsCreateDocument(true);
          }}
        >
          Upload Documents
        </Button>
        <br />
        {uplodedDocumentList?.length > 0 && (
          <List
            dataSource={uplodedDocumentList}
            renderItem={(item) => (
              <List.Item>
                <Typography.Text>{item?.docname}</Typography.Text>
                <Typography.Text>{item?.docdname}</Typography.Text>
              </List.Item>
            )}
          />
        )}
        <br />
        <p>
          Are you sure you want to complete the verification of the selected
          yields?
        </p>
      </Modal>

      <AddDocument
        ids={selectedRowKeys}
        entity="asset"
        updateDocument={displayDocument}
        isCreate={isCreateDocument}
        closeModal={closeDocumentModal}
      />

      {isYieldEditing && (
        <HandleYieldButtons
          isYieldEdit={isYieldEditing}
          selectedYieldRecord={selectedRowsUpdated}
          closeModal={closeModal}
          refetchYields={refetchYields}
        />
      )}

      <Modal
        title="Emission Breakdown"
        open={emissionBreakdownModalOpen}
        onCancel={closeEmissionBreakdownModal}
        footer={[
          <Button key="close" onClick={closeEmissionBreakdownModal}>
            Close
          </Button>,
        ]}
        width={600}
      >
        {emissionBreakdownLoading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin />
          </div>
        ) : emissionBreakdownData ? (
          <div>
            <Typography.Title level={5}>Estimated</Typography.Title>
            <Table
              size="small"
              pagination={false}
              dataSource={[
                {
                  key: "baseline",
                  type: "Baseline",
                  total: emissionBreakdownData.estimated?.totalAsset?.baseline?.toFixed(2) ?? "-",
                },
                {
                  key: "project",
                  type: "Project",
                  total: emissionBreakdownData.estimated?.totalAsset?.project?.toFixed(2) ?? "-",
                },
                {
                  key: "reduction",
                  type: "Reduction",
                  total: emissionBreakdownData.estimated?.totalAsset?.reduction?.toFixed(2) ?? "-",
                },
              ]}
              columns={[
                { title: "Type", dataIndex: "type", key: "type" },
                { title: "tCO2e", dataIndex: "total", key: "total" },
              ]}
            />
            {emissionBreakdownData.realized && (
              <>
                <Divider />
                <Typography.Title level={5}>Realized</Typography.Title>
                <Table
                  size="small"
                  pagination={false}
                  dataSource={[
                    {
                      key: "baseline",
                      type: "Baseline",
                      total: emissionBreakdownData.realized?.totalAsset?.baseline?.toFixed(2) ?? "-",
                    },
                    {
                      key: "project",
                      type: "Project",
                      total: emissionBreakdownData.realized?.totalAsset?.project?.toFixed(2) ?? "-",
                    },
                    {
                      key: "reduction",
                      type: "Reduction",
                      total: emissionBreakdownData.realized?.totalAsset?.reduction?.toFixed(2) ?? "-",
                    },
                  ]}
                  columns={[
                    { title: "Type", dataIndex: "type", key: "type" },
                    { title: "tCO2e", dataIndex: "total", key: "total" },
                  ]}
                />
              </>
            )}
          </div>
        ) : (
          <Typography.Text type="secondary">
            No breakdown data available for this asset/period.
          </Typography.Text>
        )}
      </Modal>
    </Spin>
  );
}
export default ViewYields;
